
import { useTranslation } from 'react-i18next';

export default function AboutHeroSection() {
  const { t } = useTranslation();

  return (
    <section 
      className="pt-24 pb-20 relative overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(59, 130, 246, 0.8), rgba(147, 51, 234, 0.8)), url('/resources/about-hero-001.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white relative z-10">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            {t('about_title')}
          </h1>
          <p className="text-lg md:text-xl mb-2 text-blue-100">
            About Koluno
          </p>
          <p className="text-xl md:text-2xl mb-12 text-blue-100 max-w-3xl mx-auto leading-relaxed">
            {t('about_subtitle')}
          </p>
          
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <i className="ri-global-line text-4xl mb-4"></i>
              <h3 className="text-xl font-semibold mb-2">{t('about_global_vision')}</h3>
              <p className="text-blue-100">{t('about_global_vision_desc')}</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <i className="ri-team-line text-4xl mb-4"></i>
              <h3 className="text-xl font-semibold mb-2">{t('about_professional_team')}</h3>
              <p className="text-blue-100">{t('about_professional_team_desc')}</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <i className="ri-trophy-line text-4xl mb-4"></i>
              <h3 className="text-xl font-semibold mb-2">{t('about_excellent_results')}</h3>
              <p className="text-blue-100">{t('about_excellent_results_desc')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
